import type { DeviceDefinition } from "@medplum/fhirtypes";
import { DEVICE_DEFINITION_COLLECTION_NAME } from "../../fhir";
import { createSubscriptionHook } from "./create-subscription-hook";

/** Keeps redesigned device-definition declarations current for protocol parameter authoring. */
export const useDeviceDefinitionSubscription = createSubscriptionHook<DeviceDefinition>(
  "DeviceDefinition",
  DEVICE_DEFINITION_COLLECTION_NAME,
);
